export const FETCH_TEA_TYPE_SUCCESS = "FETCH_TEA_TYPE_SUCCESS";
export const FETCH_TEA_TYPE_FAIL = "FETCH_TEA_TYPE_FAIL";
export const FETCH_TEA_TYPE = "FETCH_TEA_TYPE";
export const FETCH_SUB_TEATYPE_REQUEST = 'FETCH_SUB_TEATYPE_REQUEST';
export const FETCH_SUB_TEATYPE_SUCCESS = 'FETCH_SUB_TEATYPE_SUCCESS';
export const FETCH_SUB_TEATYPE_FAILURE = 'FETCH_SUB_TEATYPE_FAILURE';